require("!!/Users/fabian/Sites/sun/node_modules/script-loader/addScript.js")(require("!!/Users/fabian/Sites/sun/node_modules/raw-loader/index.js!/Users/fabian/Sites/sun/node_modules/chart.js/dist/Chart.bundle.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/chart.js/dist/Chart.bundle.min.js
// module id = 184
// module chunks = 10